const CBE2 = [637214,638660,638702,641605,641607,642206,641001,641002,641003,641008,641009,641033,641037,641038,641039,641041,641050,641202,641402,641601,641602,641603,641604,641606,641654,641658,641662,641663,641664,641665,641668,641669,641671,641687,642120,642201,642202,642203];
const ERD2 = [636309,636454,637201,637205,637209,637210,637304,638006,638007,638008,638181,638182,638183,638001,638002,638003,638004,638009,638010,638011,638012,638051,638052,638053,638056,638057,638060,638101,638102,638104,638106,638107,638108,638109,638110,638112,638115,638116,638153,638154,638312,638315,638402,638455,638459,638812,620008,641301,641305,641653];
const IND2 = [563147,560001,560002,560003,560004,560005,560006,560007,560008,560009,560010,560011,560012,560013,560015,560016,560017,560018,560021,560022,560024,560025,560026,560027,560032,560033,560034,560035,560037,560041,560043,560049,560050,560051,560053,560054,560055,560056,560057,560058,560059,560061,560062,560063,560064,560065,560066,560067,560070,560072,560074,560075,560076,560078,560079,560082,560083,560084,560085,560086,560088,560090,560093,560094,560095,560098,560099,560102,560103,560104,560105,560107,560109,560110,560113,560117,560300,560500,562107,562123,562149,562157,562109,562160,560020,560023,560030,560036,560038,560046,560048,560060,560068,560071,560073,560077,560080,560081,560087,560089,560091,560092,560096,560097,560100,560108,560111,560112,560115,560116,561101,561201,561203,561204,561205,562106,562110,562111,562114,562125,562127,562129,562130,562131,562132,562135,562162,562163,562164,562161,563130];
const MDU2 = [624005,624303,630602,630606,630609,630611,630612,625001,625002,625003,625004,625005,625006,625007,625008,625009,625011,625012,625014,625015,625016,625017,625018,625019,625020,625021,625022,625023,625101,625103,625104,625106,625107,625109,625110,625122,625201,625205,625207,625214,625218,625221,625234,625301,625402,625501,625503,625514,625532,625537,625701,625702,625703,625704,625705,625706,625707,625708,625203,626115,626127,628503,628720,628904,627415,627805];
const MGP2 = [600019,600037,600049,600050,600051,600052,600054,600055,600060,600062,600067,600071,600072,600076,600077,600087,600095,600107,600110,600120,601203,602024,600001,600002,600003,600004,600005,600006,600007,600008,600009,600010,600011,600012,600013,600014,600015,600017,600018,600020,600021,600022,600023,600024,600025,600026,600028,600030,600031,600032,600033,600034,600035,600036,600038,600039,600041,600042,600078,600081,600082,600083,600084,600085,600086,600092,600093,600099,600101,600102,600104,600106,600118,600016,600043,600044,600061,600069,600070,600073,600074,600075,600088,600089,600091,600096,600100,600119,600125];
const MOT2 = [689110,689111,689112,689113,689115,689531,695001,695002,695003,695004,695005,695006,695007,695008,695009,695013,695020,695021,695022,695023,695024,695025,695026,695027,695028,695029,695030,695032,695033,695034,695036,695038,695040,695042,695043,695099,695101,695102,695103,695104,695121,695122,695123,695124,695125,695126,695132,695133,695134,695304,695316,695501,695502,695503,695504,695505,695506,695507,695508,695512,695513,695521,695527,695541,695542,695543,695547,695551,695561,695562,695563,695564,695568,695570,695571,695572,695573,695574,695575,695581,695582,695583,695584,695585,695586,695587,695588,695589,695606,695607];
const MYS2 = [571419,571477,571606,570001,570002,570003,570004,570005,570006,570007,570008,570009,570010,570011,570012,570014,570015,570016,570017,570018,570019,570020,570022,570023,570025,570026,570027,570028,570029,570030,570031,570032,571101,571102,571103,571105,571108,571114,571116,571118,571119,571120,571121,571124,571125,571128,571129,571130,571189,571301,571302,571311,571312,571314,571315,571602,571603,571604,571617,571320,571442];
const OMR2 = [600053,600040,600090,600094,600113,600045,600046,600047,600048,600097,600116,600117,600122,600126,600127,600128,601301,602105,602106,602108,602117,603002,603003,603101,603103,603104,603105,603108,603109,603110,603111,603112,603201,603202,603204,603302,603303,603304,603305,603306,603308,603310,603312,631202,631402,631502,631553,631601,631604,631605,631606,631701,600103,601204];
const PNY2 = [605001,605002,605003,605004,605005,605006,605007,605008,605009,605010,605011,605013,605014,605101,605102,605106,605107,605110,605111,605105,605109,605501,636102,607001,607006,607102,607104,607105,607109,607112,609101,610004]
const SLM2 = [636001,636003,636004,636006,636007,636009,636010,636011,636012,636013,636014,636015,636016,636017,636030,636101,636103,636104,636106,636108,636109,636110,636111,636112,636113,636114,636119,636122,636138,636139,636140,636203,636204,636302,636304,636305,636307,636308,636351,636354,636451,636452,636453,636455,636501,636502,636503,636601,636602,637101,637102,637103,637104,637107,637301,637407,637410,637501,637502,637504,636301,637408,637503,637505,638151,636905];
const TAM2 = [600130,600131,600132,603001,603004,603102,603106,603107,603127,603209,603210,603211,603307,603405,603406,631561,631603,631702,641401];
const TPR2 = [638751,638752,641407,641652,641666,641670];
const TRY2 = [637208,620004,620005,620006,620007,620009,620010,620011,620012,620013,620014,620015,620016,620018,620019,620020,620021,620022,620023,620024,620025,620026,620101,620102,621008,621105,621112,621213,621218,621702,621703,621706,621712,639101,639103,639115,621717,621705,614715,613102,613103,613104,613105,613402,613602,621316,622101,622502,622504,622515,636705];
const TVL2 = [624708,630003,623502,623536,628003,628004,628005,628006,628007,628008,628201,628203,628205,628207,628208,628210,628211,628213,628217,628218,628219,628229,628251,628252,628601,628612,628613,628614,628615,628616,628617,628618,628619,628620,628622,628623,628653,628656,628701,628702,628703,628704,628721,628751,628752,628753,628801,628802,628809,627001,627002,627003,627004,627005,627006,627007,627008,627009,627011,627106,627107,627108,627110,627113,627117,627118,627119,627120,627151,627152,627352,627354,627355,627356,627602,627652,627654,627657,627860,627861,627862];
const VLR2 = [631003,631051,631102,632001,632002,632004,632006,632007,632008,632057,632058,632101,632102,632103,632104,632105,632113,632114,632201,632202,632203,632204,632311,632312,632319,632404,632503,632504,632506,632507,632509,632512,632514,632517,632518,632520,632521,632531,632601,632603,635602,635652,635653,635654,635655,635701,635710,635754,635801,635802,635804,635808,635809,635810,635813,635814,635815,635852,635853,635854,635901,606710,606903,606905,606907,632301,632314,632315,632317];
const LNK2 = [400701,400703,400706,400708,400709,400710,401405,421306,400001,400002,400003,400004,400005,400006,400007,400008,400009,400010,400011,400012,400013,400014,400015,400016,400017,400018,400019,400020,400021,400022,400024,400025,400026,400027,400028,400029,400030,400031,400032,400033,400034,400035,400037,400042,400043,400049,400050,400051,400052,400053,400054,400055,400056,400057,400058,400059,400061,400063,400064,400068,400069,400070,400071,400072,400074,400075,400076,400077,400078,400079,400080,400081,400082,400083,400084,400085,400086,400087,400088,400089,400092,400104,400702,400704,400707,402107,402109,402111,402201,402202,402204,402207,402208,402209,402301,402308,410202,410207,410210,410216,410218];
const MUL2 = [400601,400602,400603,400604,400605,400606,400607,400608,400610,400612,400614,400615,400701,400703,400706,400708,400709,400710,401106,401107,401201,401202,401203,401206,401207,401208,401209,401304,401305,401401,401402,401404,401405,401606,421103,421201,421202,421203,421204,421301,421302,421305,421306,421308,400001,400002,400003,400004,400005,400006,400007,400008,400009,400010,400011,400012,400013,400014,400015,400016,400017,400018,400019,400020,400021,400022,400024,400025,400026,400027,400028,400029,400030,400031,400032,400033,400034,400035,400037,400042,400043,400049,400050,400051,400052,400053,400054,400055,400056,400057,400058,400059,400060,400061,400063,400064,400065,400066,400067,400068,400069,400070,400071,400072,400074,400075,400076,400077,400078,400079,400080,400081,400082,400083,400084,400085,400086,400087,400088,400089,400091,400092,400093,400094,400095,400096,400097,400098,400099,400101,400102,400103,400104,400702,400704,400707,402107,402109,402201,402204,402207,402208,402308,410102,410207,410210,410216,410218];
const PAN2 = [431109,431148,422401,401102,401604,410502,410504,410508,410510,410511,410516,412208,413201,413204,413205,413701,413702,413704,413705,413706,413707,413708,413709,413710,413711,413712,413715,413717,413718,413721,413723,413725,413728,413736,413737,413738,413739,414002,414005,414006,414101,414102,414103,414105,414106,414111,414113,414301,414302,414303,414304,414305,414401,414402,414403,414501,414502,414503,414505,414601,414602,414603,414604,414606,414607,414609,414701,422601,422602,422604,422605,422608,422610,423107,423109,423601,423602,423603,416314,410206];
const SWD2 = [400601,400602,400603,400604,400605,400606,400607,400608,400610,400612,400614,400615,400701,400703,400706,400708,400709,400710,401106,401107,401201,401202,401203,401206,401207,401208,401209,401304,401305,401401,401402,401404,401405,401606,421103,421201,421202,421203,421204,421301,421302,421305,421306,421308,400001,400002,400003,400004,400005,400006,400007,400008,400009,400010,400011,400012,400013,400014,400015,400016,400017,400018,400019,400020,400021,400022,400024,400025,400026,400027,400028,400029,400030,400031,400032,400033,400034,400035,400037,400042,400043,400049,400050,400051,400052,400053,400054,400055,400056,400057,400058,400059,400060,400061,400063,400064,400065,400066,400067,400068,400069,400070,400071,400072,400074,400075,400076,400077,400078,400079,400080,400081,400082,400083,400084,400085,400086,400087,400088,400089,400091,400092,400093,400094,400095,400096,400097,400098,400099,400101,400102,400103,400104,400702,400704,400707,402107,402109,402201,402204,402207,402208,402308,410102,410207,410210,410216,410218];
const WAK2 = [401102,401204,401302,401303,421101,421102,421303,421503,410101,410208,400060,400065,400066,400067,400091,400093,400094,400095,400096,400097,400098,400099,400101,400102,400103,410102];
const VAS2 = [400601,400602,400603,400604,400605,400606,400607,400608,400610,400612,400614,400615,400701,400703,400706,400708,400709,400710,401106,401107,401401,401402,401404,401405,401606,421103,421201,421202,421203,421204,421301,421302,421305,421306,421308,421503,400001,400002,400003,400004,400005,400006,400007,400008,400009,400010,400011,400012,400013,400014,400015,400016,400017,400018,400019,400020,400021,400022,400024,400025,400026,400027,400028,400029,400030,400031,400032,400033,400034,400035,400037,400042,400043,400049,400050,400051,400052,400053,400054,400055,400056,400057,400058,400059,400060,400061,400063,400064,400065,400066,400067,400068,400069,400070,400071,400072,400074,400075,400076,400077,400078,400079,400080,400081,400082,400083,400084,400085,400086,400087,400088,400089,400091,400092,400093,400094,400095,400096,400097,400098,400099,400101,400102,400103,400104,400702,400704,400707,402107,402109,402201,402204,402207,402208,402209,402308,410101,410102,410202,410207,410210,410216,410218];

$(document).ready(function () {
  const customerinfo = {
    "CustomerFirstName": "",
    "CustomerLastName": "",
    "CustomerMobileNo": "",
    "CustomerEmailId": "",
    "CustomerAlternateMobileNo": "",
    "CustomerAddressLine1": "",
    "CustomerAddressLine2": "",
    "CustomerAddressLine3": "",
    "CustomerAddressLandmark": "",
    "CustomerPincode": "",
    "CustomerState": "",
    "CustomerCity": "",
    "CustomerCountry": "IND"
  }, productinfo = {
    "ProductFamily": "",
    "ProductDescription": "",
    "SerialNo": "NA",
    "WarrantyStatus": "",
    "ProblemOrRemark": "",
    "issueList": []
  }, paymentinfo = {
    "PaymentMode": "NA",
    "Amount": 0,
    "PaymentTransactionNo": ""
  }, data = {
    "customerinfo": customerinfo,
    "productinfo": productinfo,
    "paymentinfo": paymentinfo,
  };
  var itemComponent = "", userState = "";
  $(".repair-next-button").click(function () {
    const _this = $(this);
    const _parent = _this.parents(".repair-div");
    const id = _this.attr("href");
    let pass = false;
    let check = false;
    let regexE,
      regexP,
      name_regex = false;
    let vald = false;
    let value;
    let valdE, valdP, valdN, validPin;
    $(".repair-page-error").hide();
    if (id == "#repair-2") {
      regexE = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,12}$/i;
      regexM = /^[6-9]\d{9}$/;
      name_regex = /^(?=.{1,50}$)[a-z]+(?:['_.\s][a-z]+)*$/i;
      
      pass = _parent
        .find("input")
        .filter((i) => _parent.find("input")[i].value == "");
      check = _parent
        .find("input")
        .filter((i) => _parent.find("input")[i].checked == true);
      customerinfo.CustomerFirstName = _parent.find("input#first-name").val(), 
      customerinfo.CustomerEmailId = _parent.find("input#email").val(),
      customerinfo.CustomerMobileNo = _parent.find("input#phone").val();
      valdE = regexE.test(_parent.find("input#email").val());
      valdP = regexM.test(_parent.find("input#phone").val());
      valdN = name_regex.test(_parent.find("input#first-name").val());
      validPin = locationCode(_parent.find("input#pincode").val());
      if (pass.length != 0) {
        _parent.find(".empty-fields").show();
        _parent.find(".email_error").hide();
        _parent.find(".phone_error").hide();
        _parent.find(".name_error").hide();
        _parent.find(".checkbox-error").hide();
      } else if (!valdE || !valdP || !valdN) {
        _parent.find(".empty-fields").hide();
        !valdE && _parent.find(".email_error").show();
        !valdP && _parent.find(".phone_error").show();
        !valdN && _parent.find(".name_error").show();
        _parent.find(".checkbox-error").hide();
      } else if(_parent.find("input#pincode").val().length !== 6) {
        _parent.find(".empty-fields").hide();
        _parent.find(".email_error").hide();
        _parent.find(".phone_error").hide();
        _parent.find(".name_error").hide();
        _parent.find(".pincode_error").text("Please Enter valid pincode");
        _parent.find(".pincode_error").show();
        _parent.find(".checkbox-error").hide();
      }else if(validPin === "") {
        _parent.find(".empty-fields").hide();
        _parent.find(".email_error").hide();
        _parent.find(".phone_error").hide();
        _parent.find(".name_error").hide();
        _parent.find(".pincode_error").text("We don't provide service here.");
        _parent.find(".pincode_error").show();
        _parent.find(".checkbox-error").hide();
      } else if (check.length == 0) {
        _parent.find(".empty-fields").hide();
        _parent.find(".email_error").hide();
        _parent.find(".phone_error").hide();
        _parent.find(".name_error").hide();
        _parent.find(".checkbox-error").show();
      } else {
        _parent.find(".empty-fields").hide();
        _parent.find(".email_error").hide();
        _parent.find(".phone_error").hide();
        _parent.find(".name_error").hide();
        _parent.find(".checkbox-error").hide();
        _parent.removeClass("action");
        $(id).addClass("action");
      }
    } else if (id == "#repair-3") {
      $(`.pick-device-radios`).removeClass("selected");
      check = _parent
        .find("input")
        .filter((i) => _parent.find("input")[i].checked == true);
      value = check[0]?.value;
      const deviceError = check[0]?.value;
      productinfo.ProblemOrRemark = deviceError === undefined ? "": deviceError;
      const family = check[0]?.getAttribute("data-family");
      const img_src = check[0]?.getAttribute("img_src");
      check.length == 0 && _parent.find(".repair-page-error").show();
      check.length == 1 && $(".right-content").addClass("action");
      check.length == 1 && _parent.removeClass("action");
      $(".active-product-head").html(
        `<img src="${img_src}"/><p class="phone_title">${value}</p`
      );
      value = value == "AppleTV" ? "Mac" : value;
      value = value == "ipod" ? "Homepod" : value;
      value = value == "ipad" ? "Iphone" : value;
      check.length == 1 &&
        $(id).addClass("action") &&
        $(`.pick-device-radios.${value.replace(" ", "")}`).addClass("selected");
      check.length == 1 &&
        $(`[href='#${_parent.attr("id")}']`)
          .find("span")
          .text(_parent.find("input").val());
      check.length == 1 && $(`[href="${id}"]`).show();
      productinfo.ProductFamily = family === undefined ? "" : family;
    } else if (id == "#repair-4") {
      check = _parent
        .find("input")
        .filter((i) => _parent.find("input")[i].checked == true);
      value = check[0]?.value;
      check.length == 0 && _parent.find(".repair-page-error").show();
      check.length == 1 && _parent.removeClass("action");
      check.length == 1
        ? check[0].value == "Out of Warranty"
          ? $("#repair-5").addClass("action")
          : $(id).addClass("action")
        : null;
      check.length == 1 &&
        $(`[href='#${_parent.attr("id")}']`)
          .find("span")
          .text(value);
      check.length == 1
        ? check[0].value != "Out of Warranty"
          ? $(`li[href="#repair-4"]`).removeAttr("disabled")
          : $(`li[href="#repair-4"]`).attr("disabled", "true")
        : null;
      if (check.length == 1 && check[0].value == "Out of Warranty") {
        $(`.right-content li[href="${id}"]`).show();
      } else {
        $(`.right-content li[href="${id}"]`).hide();
        $('.right-content li[href="#repair-5"]').show();
      }
      const warranty = check[0]?.getAttribute("data-value");
      productinfo.WarrantyStatus = warranty === undefined ? "" : warranty; 
    } else if (id == "#repair-6") {
      pass = _parent
        .find("input")
        .filter((i) => _parent.find("input")[i].value == "");
      pass.length == 1 && _parent.find(".repair-page-error").show();
      pass.length == 0 && _parent.removeClass("action");
      pass.length == 0 && $(id).addClass("action");
      pass.length == 0 &&
        $(`[href='#${_parent.attr("id")}']`)
          .find("span")
          .text(_parent.find("input").val());
      pass.length == 0 && $(`[href="${id}"]`).show();
      const serialNumber = _parent.find(`input[id='serial']`)[0].value;
      productinfo.SerialNo = serialNumber;
    } else {
      check = _parent
        .find("input")
        .filter((i) => _parent.find("input")[i].checked == true);
      if(id == "#repair-7") {
        itemComponent = check[0]?.value === undefined ? "" : check[0]?.value;
      }
      if(id == "#repair-8") {
        var allReasons = document.querySelector(".repair-div#repair-7")?.querySelectorAll("input:checked");
        productinfo.issueList = [];
        if(allReasons.length) {
          allReasons.forEach((reason, index) => {
            productinfo.issueList.push({
              "ItemNo": index,
              "Component": itemComponent,
              "Issue": reason.value
            });
          });
        }
      }
      value = check[0]?.value;
      let values = check?.map((i) => check[i].value);
      let allvalue = "";
      values.each(
        (i) =>
          (allvalue = i > 0 ? allvalue + "," + values[i] : allvalue + values[i])
      );
      check.length == 0 && _parent.find(".repair-page-error").show();
      check.length >= 1 && id != "#repair-8" && _parent.removeClass("action");
      check.length >= 1 && $(id).addClass("action");
      check.length >= 1
        ? id == "#repair-8"
          ? $(`[href='#${_parent.attr("id")}']`)
              .find("span")
              .text(allvalue)
          : $(`[href='#${_parent.attr("id")}']`)
              .find("span")
              .text(value)
        : null;
      id == "#repair-8" && $('html').css('overflow','hidden')
      check.length >= 1 && $(`[href="${id}"]`).show();

      check.length >= 1 &&
        id == "#repair-7" &&
        $(`.pick-device-radios.selected .choose`).removeClass("choose");
      check.length >= 1 &&
        id == "#repair-7" &&
        $(
          `.pick-device-radios.selected .select-issue-${value.toLowerCase()}`
        ).addClass("choose");
    }
  });
  $(".repair-prev-button").on("click", function () {
    const href = $(this).attr("href");
    $(".repair-div.action").removeClass("action");
    $(`[prev="${href}"`).addClass("action");
    href == "#repair-1" && $(".right-content").removeClass("action");
    href == "#repair-2" && $(".right-content").removeClass("action");
    let hide_val = false;
    $('[name="radio-issue"]').removeAttr("checked");
    $(".active-repair-options ul li").each(function () {
      if (href == $(this).attr("href")) {
        hide_val = true;
      } else if (hide_val) {
        $(this).hide();
      }
    });
  });
  $(".cross-icon").on("click", function () {
    $(this).parents(".repair-div").removeClass("action");
    $('html').css('overflow','auto');
  });
  
  $(".book-repair").click(function () {
    validateForm();
    $('html').css('overflow','auto');
  });
  
  $("#repair-pincode").on("keyup", function() {
    var value = $(this).val();
    if(value.length === 6) {
      var userState = locationCode(value);
      if(userState !== "") {
        var index = $(".state-dropdown").find(`option[value="${userState}"]`).index();
        $(".state-dropdown").find(`option[value="${userState}"]`).attr("selected", "selected");
        $(".state-dropdown").prop("selectedIndex", index);
        $(this).parent(".address-fields").find(".pincodeError").remove();
      } else {
        $(this).parent(".address-fields").find(".pincodeError").remove();
        $(this).parent(".address-fields").append("<span class='pickup-pincode-error pincodeError'>We don't provide service here.</span>")
      }
    }
  });
  $(".pincodeField").on("keyup", function() {
    var value  = $(this).val();
    if(value.length === 6) {
      var userState = locationCode(value);
      if(userState !== "") {
        $(this).parent(".pincode").find(".pincode_error").css("display", "none");
        $(this).parent(".pincode").find(".pincode_error").text("");
      } else {
        $(this).parent(".pincode").find(".pincode_error").css("display", "block");
        $(this).parent(".pincode").find(".pincode_error").text("We don't provide service here.");
      }
    } else {
      $(this).parent(".pincode").find(".pincode_error").css("display", "none");
      $(this).parent(".pincode").find(".pincode_error").text("");
    }
  });
  function validateForm() {
    var adderess = $("#repair-address").val(), locality = $("#repair-locality").val(), landmark = $("#repair-landmark").val(),
      pincode = $("#repair-pincode").val(), area = $("#repair-city").val(), mobile = $("#repair-number").val(), 
      comment = $("#repair-comment").val(), checkbox = $("#confirm_add").prop("checked"), city = "";
    if(pincode.length === 6) {
      var userState = locationCode(pincode);
      if(userState !== "") {
        city = userState;
        var index = $(".state-dropdown").find(`option[value="${userState}"]`).index();
        $(".state-dropdown").find(`option[value="${userState}"]`).attr("selected", "selected");
        $(".state-dropdown").prop("selectedIndex", index);
        $("#repair-pincode").parent(".address-fields").find(".pincodeError").remove();
      } else {
        $("#repair-pincode").parent(".address-fields").find(".pincodeError").remove();
        $("#repair-pincode").parent(".address-fields").append("<span class='pickup-pincode-error pincodeError'>We don't provide service here.</span>")
      }
    }
    customerinfo.CustomerAddressLine1 = adderess, customerinfo.CustomerAddressLine2 = locality,
    customerinfo.CustomerAddressLandmark = landmark, customerinfo.CustomerPincode = pincode,
    customerinfo.CustomerAddressLine3 = area, customerinfo.CustomerAlternateMobileNo = mobile,
    customerinfo.CustomerCity = city, productinfo.ProductDescription = comment;
    if (
      !adderess ||
      !locality ||
      !landmark ||
      !area ||
      !comment ||
      !pincode ||
      !mobile
    ) {
      $(".empty-fields").css("display", "block");
      $(".empty-fields").text("Please fill all details");
    } else if (mobile.length !== 10 || !mobile.match(/^[6-9]\d{9}$/)) {
      $(".pickup-tel-error").css("display", "block");
      $(".empty-fields").css("display", "none");
      $(".empty-fields").text("Please fill all details");
    }else if (pincode.length !== 6) {
      $(".pickup-pincode-error").css("display", "block");
      $(".pickup-tel-error").css("display", "none");
      $(".empty-fields").css("display", "none");
      $(".empty-fields").text("Please fill all details");
    }else if (!checkbox) {
      $(".pickup-checkbox-error").css("display", "block");
      $(".pickup-tel-error").css("display", "none");
      $(".pickup-pincode-error").css("display", "none");
      $(".empty-fields").css("display", "none");
      $(".empty-fields").text("Please fill all details");
    } else {
      $(".pickup-checkbox-error").css("display", "none");
      $(".pickup-tel-error").css("display", "none");
      $(".empty-fields").css("display", "none");
      $(".empty-fields").text("Please fill all details");
      startReservation(data);
    }
  }

  $('body').on('keypress','#repair-pincode, #repair-number, [name="phone"], .pincodeField',function(e){
    const number = (e.key).replace(/\D/g, "")
    // console.log('1....')
    if(number == ''){
      return false;
    }
  });

  function startReservation(data) {
    $(".book-repair").addClass("disabled");
    // console.log("data", data);
    fetch(`https://api.iplanet.one/workscan/savereservation`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json"
      },
      body: JSON.stringify(data)
    }).then((response) => {
      return response.json();
    }).then((response) => {
      if(response.success) {
        const reservationId = response.data;
        if (reservationId.code != "0") {
          $(".book-repair").removeClass("disabled");
          $(".empty-fields").css("display", "block");
          $(".empty-fields").text(reservationId.message);
        } else {
          $(".empty-fields").css("display", "none");
          $(".empty-fields").text("Please fill all details");
          $(".exchange-id").text(reservationId.ServiceRefNo)
          $(".repair-div, .right-content").removeClass("action");
          $(".exchange-thankyou").addClass("action");
        }
        // console.log("reservationId", reservationId);
      } else {
        console.log("response", response);
      }
    }).catch((error) => {
      console.error("error: ", error);
    });
  }
});

const locationCode = (code) => {
  let locationID = "";
  switch (true) {
    case CBE2.includes(parseInt(code)) :
      locationID = "Coimbatore"
      break;
    case ERD2.includes(parseInt(code)) :
      locationID = "Erode"
      break;
    case IND2.includes(parseInt(code)) :
      locationID = "Bangalore"
      break;
    case MDU2.includes(parseInt(code)) :
      locationID = "Madhurai";
      break;
    case MGP2.includes(parseInt(code)) :
      locationID = "Chennai"
      break;
    case MOT2.includes(parseInt(code)) :
      locationID = "Kerla"
      break;
    case MYS2.includes(parseInt(code)) :
      locationID = "Bangalore"
      break;
    case OMR2.includes(parseInt(code)) :
      locationID = "Chennai"
      break;
    case PNY2.includes(parseInt(code)) :
      locationID = "Pondicheery"
      break;
    case SLM2.includes(parseInt(code)) :
      locationID = "Salem"
      break;
    case TAM2.includes(parseInt(code)) :
      locationID = "Chennai"
      break;
    case TPR2.includes(parseInt(code)) :
      locationID = "Tiruppur"
      break;
    case TRY2.includes(parseInt(code)) :
      locationID = "Trichy"
      break;
    case TVL2.includes(parseInt(code)) :
      locationID = "Thirunelvi"
      break;
    case VLR2.includes(parseInt(code)) :
      locationID = "Vellore"
      break;
    case LNK2.includes(parseInt(code)) :
      locationID = "Mumbai"
      break;
    case MUL2.includes(parseInt(code)) :
      locationID = "Mumbai"
      break;
    case PAN2.includes(parseInt(code)) :
      locationID = "Mumbai"
      break;
    case SWD2.includes(parseInt(code)) :
      locationID = "Mumbai"
      break;
    case WAK2.includes(parseInt(code)) :
      locationID = "Mumbai"
      break;
    case VAS2.includes(parseInt(code)) :
      locationID = "Mumbai"
      break;
    default :
      locationID = "";
  }
  return locationID;
}